import { render, staticRenderFns } from "./VersionNavigator.vue?vue&type=template&id=6a3ccafb&scoped=true"
import script from "./VersionNavigator.vue?vue&type=script&lang=js"
export * from "./VersionNavigator.vue?vue&type=script&lang=js"
import style0 from "./VersionNavigator.vue?vue&type=style&index=0&id=6a3ccafb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3ccafb",
  null
  
)

export default component.exports